module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/sessions-master-class.json
// module id = 423
// module chunks = 175972873406167